import gql from "graphql-tag";

import { Fragment, Task } from "../types";

export const TASK_MINIMAL_FRAGMENT = gql`
  fragment TaskMinimalFragment on Task {
    description
    id
    role
  }
`;

export type TaskMinimalFragment = Fragment<
  Task,
  Pick<Task, "id" | "description" | "role">
>;
